/* tslint:disable */
module Environments {
    module.controller("EnvironmentDetailsController", [
        "$scope",
        "$uibModal",
        "EnvironmentsService",
        "AgentsService",
        "notifications",
        function ($scope, $modal, environmentsService, agentsService, notifications) {
            var savedModel = _.find($scope.environments, function (environment: IEnvironment) {
                return environment.name === $scope.$stateParams.environmentName;
            });
            //Bind input fileds to a clone, so unsaved changes get wiped on navigation
            $scope.environment = angular.copy(savedModel);

            if (!$scope.environment) {
                $scope.$state.go("environments.agentGroup", { environmentName: "Default", agentGroupName: "Default" });
                return false;
            }

            $scope.showAgentGroupDetails = function ($event, agentGroup) {
                $scope.$state.go("environments.agentGroup", { environmentName: this.environment.name, agentGroupName: agentGroup.name });
            };
            $scope.preventEventBubbling = function ($event) {
                $event.stopPropagation();
            };

            $scope.addNewAgentGroup = function () {
                $scope.$state.go("environments.newAgentGroup", { environmentName: this.environment.name, agentGroupName: "" });
            };

            $scope.editAgentGroup = function ($event, agentGroup) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.$state.go("environments.agentGroup", { environmentName: this.environment.name, agentGroupName: agentGroup.name });
            };

            $scope.removeAgentGroup = function ($event, agentGroup) {
                $event.preventDefault();
                $event.stopPropagation();

                var deleteConfirmation = $modal.open({
                    templateUrl: "DeleteConfirmationModalPartial",
                    size: "lg",
                    resolve: {
                        itemType: function () { return FRENDS.Localizations.Agent.toLowerCase() },
                        itemName: function () { return agentGroup.name; }
                    },
                    controller: "DeleteConfirmationModalController as ctrl"
                });

                deleteConfirmation.result.then(function () {
                    environmentsService.removeAgentGroup(agentGroup).then(function (response) {
                        if (response) {
                            notifications.notify(response.data);
                            $scope.environment.agentGroups = _.without($scope.environment.agentGroups, agentGroup);
                            $scope.$state.reload();
                        }
                    });
                });
            };
        }
    ]);
}